import React from "react";
import ReactAvatar from "react-avatar";

// This avatar implements accessible colour contrast between text and background.

// accessible background colours for white text
export const colors = [
    "rgb(9, 4, 69)",
    "rgb(50, 58, 69)",
    "rgb(17, 46, 81)",
    "rgb(0, 113, 188)",
    "rgb(4, 107, 153)",
    "rgb(73, 68, 64)",
    "rgb(91, 97, 107)",
    "rgb(32, 84, 147)",
    "rgb(71, 115, 170)",
    "rgb(46, 133, 64)",
    "rgb(152, 27, 30)",
    "rgb(205, 32, 38)",
    "rgb(227, 28, 61)",
    "rgb(188, 0, 204)",
    "rgb(153, 77, 147)",
    "rgb(119, 9, 204)",
    "rgb(204, 17, 125)",
    "rgb(48, 129, 125)",
];

const InitialAvatar = (props) => {
    const lastLetter = props.name.substring(props.name.length - 1, props.name.length);
    return (
        <ReactAvatar
            {...props}
            color={ReactAvatar.getRandomColor(lastLetter, colors)}
            aria-hidden="true"
        />
    );
};

export default InitialAvatar;
